import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CustomerGreenClassificationArrayModel,
  CustomerGreenClassificationModel,
} from "../../models/CustomerGreenClassificationModel";

const initialState: CustomerGreenClassificationArrayModel = {
  all_Customer_Green_Classfications: [],
  isCustomerGreenClassificationsFetching: false,
};
const CustomerGreenClassificationSlice = createSlice({
  name: "CustomerGreenClassification",
  initialState: initialState,
  reducers: {
    setCustomerGreenClassifications(
      state,
      action: PayloadAction<CustomerGreenClassificationModel[]>
    ) {
      state.all_Customer_Green_Classfications = action.payload;
    },
    setIsCustomerGreenClassificationsFetching(
      state,
      action: PayloadAction<boolean>
    ) {
      state.isCustomerGreenClassificationsFetching = action.payload;
    },
  },
});
export default CustomerGreenClassificationSlice;
